import Vue from 'vue';
import Vuex from 'vuex';

import activities from './modules/activities';
import alerts from './modules/alerts';
import cloud from './modules/cloud';
import cloudUploads from './modules/cloud-uploads';
import companies from './modules/companies';
import contractors from './modules/contractors';
import creditCalculation from './modules/credit-calculation';
import contractorPermissions from './modules/contractor-permissions';
import contractorTime from './modules/contractor-time';
import copyCompany from './modules/copy-company';
import employeeUploads from './modules/employee-uploads';
import employees from './modules/employees';
import employeesUploads from './modules/employees-uploads';
import exports from './modules/exports';
import flags from './modules/flags';
import industries from './modules/industries';
import legacyEmployees from './modules/legacy-employees';
import messaging from './modules/messaging';
import progress from './modules/progress';
import projects from './modules/projects';
import questionnaire from './modules/questionnaire';
import session from './modules/session';
import stages from './modules/stages';
import supplies from './modules/supplies';
import suppliesUploads from './modules/supplies-uploads';
import taxReturn from './modules/tax-return';
import timesurvey from './modules/time-survey';
import uploads from './modules/uploads';
import users from './modules/users';
import version from './modules/version';
import prospectLookup from './modules/prospect-lookup';

Vue.use(Vuex);

export default new Vuex.Store({
   modules: {
      activities,
      alerts,
      cloud,
      cloudUploads,
      companies,
      contractors,
      creditCalculation,
      contractorPermissions,
      contractorTime,
      copyCompany,
      employeeUploads,
      employees,
      employeesUploads,
      exports,
      flags,
      industries,
      legacyEmployees,
      messaging,
      progress,
      projects,
      questionnaire,
      session,
      stages,
      supplies,
      suppliesUploads,
      taxReturn,
      timesurvey,
      uploads,
      users,
      version,
      prospectLookup,
   },
});
